export const initialValuesEditMdp = 
{
    newPassword: "",
    newPasswordConfirmation: "",
}